import './buttonStyle.css'
export default function Button({text, url})
{
    return (
        <button className="main-button" onClick={()=> window.open(url)}>
            {text}
        </button>
    )
}